// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__10cpZ","body":"styles_body__1s1Jv"};